module.exports = __webpack_public_path__ + "static/media/logo.d0720023.svg";